import {StyledFocusMessageText, StyledFocusPopover} from './PopulationDensityDropDownStyle'
import HouseholdWithDotsAndConcentration from '../../../icons/household_dot_and_concentration.png'
import HouseholdWithDots from '../../../icons/household_dot_only.png'
import HouseholdWithConcentration from '../../../icons/household_concentration_only.png'
import PropTypes from 'prop-types'
import MenuWithRadioButton from './MenuWithRadioButton'

const FocusLayerMenu = ({
  visualEL,
  hoverEL,
  getViewerVisualOptions,
  handleFocusLayerChange,
  selectedFocusLayer,
  handleMenuClose,
  menuStyleProps,
  isFocusLayerEnabled
}) => {
  const visualOptions = getViewerVisualOptions()
  const imageMap = {
    householdConcentration: HouseholdWithConcentration,
    individualHouseholds: HouseholdWithDots,
    both: HouseholdWithDotsAndConcentration
  }

  const messageMap = {
    both: 'Individual Household or Concentration',
    householdConcentration: 'Household Concentration',
    individualHouseholds: 'Individual Household'
  }
  const imageKey = visualOptions.length > 1 ? 'both' : visualOptions[0].value
  const image = imageMap[imageKey]

  if (!isFocusLayerEnabled) {
    return (
      <StyledFocusPopover
        anchorEl={hoverEL}
        open={Boolean(hoverEL)}
        onClose={handleMenuClose}
        slotProps={{paper: menuStyleProps}}
        transformOrigin={{horizontal: 'top', vertical: 'right'}}
        anchorOrigin={{horizontal: 'right', vertical: 'top'}}
        disableEnforceFocus
      >
        <img src={image} width={'400px'} height={'195px'} alt='Focus Layer is not available' loading='lazy' />
        <StyledFocusMessageText>
          To view <b>{messageMap[imageKey]} </b> on the map, you need to filter <b> Unique Addresses </b> down to{' '}
          <b> below 50k for a single state </b> and <b> below 60k for multiple states.</b>
        </StyledFocusMessageText>
      </StyledFocusPopover>
    )
  }
  return (
    <MenuWithRadioButton
      anchorEl={visualEL}
      open={Boolean(visualEL)}
      label='Focus Layer'
      options={[{label: 'None', value: 'none'}, ...visualOptions]}
      onClick={handleFocusLayerChange}
      selectedValue={selectedFocusLayer}
      onClose={handleMenuClose}
      menuStyleProps={menuStyleProps}
    />
  )
}

export default FocusLayerMenu

FocusLayerMenu.propTypes = {
  visualEL: PropTypes.object,
  hoverEL: PropTypes.object,
  getViewerVisualOptions: PropTypes.func,
  handleFocusLayerChange: PropTypes.func,
  selectedFocusLayer: PropTypes.string,
  handleMenuClose: PropTypes.func,
  menuStyleProps: PropTypes.object,
  isFocusLayerEnabled: PropTypes.bool
}
